import React, { useEffect, useMemo, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch } from "react-redux";
import { setDrops } from "../../app/features/counter/counterSlice";
import "../../index.css";
import { calculateDrops } from "./quoteCalculator";
import HigherOrderComponent from "./HigherOrderComponent";

function DisplayDrops({ accessDrops, runAccessDrops, whichOption, combinedData = [] }) {
    const dispatch = useDispatch();
    const lastDropsSignatureRef = useRef("");

    const dropsSignatureInput = useMemo(() => {
        return (combinedData || [])
            .map((item) => [
                item.uniqueID || item.id || item.Product_Name || item.name || "",
                item.option || item.num_options || "",
                item.category || "",
                item.Product_Quantity || item.quantity || item.Camera_Quantity || item.Port_Quantity || 0,
                item.drop || item.extra_field_2 || "",
            ].join(":"))
            .join("|");
    }, [combinedData]);

    const allDrops = useMemo(() => {
        const grouped = (combinedData || []).reduce((acc, item) => {
            const option = item.option || item.num_options || "1";
            if (!acc[option]) acc[option] = [];
            acc[option].push(item);
            return acc;
        }, {});

        const calculatedDrops = {};

        Object.keys(grouped).forEach((option) => {
            const items = grouped[option];

            let cameraQty = 0;
            items.forEach((item) => {
                if (item.category === "Camera") {
                    cameraQty += parseInt(item.Product_Quantity || item.quantity || 0, 10);
                }
            });

            calculatedDrops[option] = calculateDrops(items, cameraQty);
        });

        return calculatedDrops;
    }, [dropsSignatureInput]);

    useEffect(() => {
        if (!runAccessDrops) return;

        const nextSignature = JSON.stringify(allDrops || {});
        if (nextSignature === lastDropsSignatureRef.current) return;

        lastDropsSignatureRef.current = nextSignature;

        if (typeof accessDrops === "function") {
            accessDrops(allDrops);
        }
        dispatch(setDrops(allDrops));
    }, [runAccessDrops, accessDrops, dispatch, allDrops]);

    return (
        <>
            <div>Total number of drops &nbsp;: <span className="fw-bold">{
                allDrops[whichOption] === undefined ? 0 : allDrops[whichOption]}</span></div>
        </>
    )
}

export default HigherOrderComponent(DisplayDrops);
